import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { faqContent } from "../../data/faqContent";
import { formatTextWithHighlight } from "../utils/formatTextWithHighlight";
import SectionYellowTitle from "../common/SectionYellowTitle";
import SectionMainTitle from "../common/SectionMainTitle";

const FAQSection: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        color: "white",
        py: { xs: 6, md: 10 },
        px: 2,
      }}
    >
      <Box
        sx={{
          py: { xs: 4, md: 6 },
        }}
      >
        <Container maxWidth="lg">
          {/* Título amarillo pequeño */}
          <SectionYellowTitle title={faqContent.subtitle} />

          {/* Subtítulo grande de venta */}
          <SectionMainTitle title={faqContent.title} mb={5} />

          {/* Preguntas frecuentes */}
          {faqContent.questions.map((faq, index) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: theme.palette.background.paper,
                borderRadius: 1,
                border: `1px solid ${theme.palette.text.disabled}`,
                color: theme.palette.secondary.main,
                mb: 2,
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={{ color: theme.palette.secondary.main }}
                  />
                }
              >
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1">
                  {formatTextWithHighlight(
                    faq.answer,
                    theme.palette.primary.main
                  )}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>
      </Box>
    </Box>
  );
};

export default FAQSection;
